var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/avatar_overlay.tsx";
import React from 'react';
import StillImage from 'soapbox/components/still_image';
const AvatarOverlay = ({
  account,
  friend
}) => /*#__PURE__*/React.createElement("div", {
  className: "account__avatar-overlay",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 13,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(StillImage, {
  src: account.avatar,
  className: "account__avatar-overlay-base",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 14,
    columnNumber: 5
  }
}), /*#__PURE__*/React.createElement(StillImage, {
  src: friend.avatar,
  className: "account__avatar-overlay-overlay",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 15,
    columnNumber: 5
  }
}));
export default AvatarOverlay;